<template>
  <div class="Header">

    <h1>
      <router-link :to="{ name: 'Home'}" class="header-link">
        Ekokammaren
      </router-link>
    </h1>

    <div class="menu">
      <h3 class="c-black">
        <router-link :to="{ name: 'About'}">Om Ekokammaren</router-link>
        |
        Vilka nyheter läser du?
      </h3>
    </div>

  </div>
</template>

<script>

//import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Header',
  components: {
  },
  data: function () {
    return {
      //name: "name"
    }
  },
  props: {
    //value: Number
  },
  computed: {
    /*...mapState([
      'stateField',
    ]),*/
    /*...mapGetters([
      'nImmune'
    ])*/
  },
  methods: {
  },
  mounted: function () {    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.Header{
  background: var(--color);
  color: white;
}

h1{
  margin-bottom: 0;
}

.header-link{
  color: white;
}

.menu{
  font-family: var(--font-header);
  display: flex;
}

.menu a {
  color: white;
  font-weight: normal;
}

.flex-cols{
  align-items: center;
}

</style>
